/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/ui/accordion";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

enum TaxType {
  ICMS = 1,
  PIS = 2,
  COFINS = 3,
  FCP = 4,
  ICMS_DESONERADO = 5,
  IBS = 6,
  CBS = 7,
}

const getTaxTypeName = (tip: number): string => {
  switch (tip) {
    case TaxType.ICMS:
      return "ICMS";
    case TaxType.PIS:
      return "PIS";
    case TaxType.COFINS:
      return "COFINS";
    case TaxType.FCP:
      return "FCP";
    case TaxType.ICMS_DESONERADO:
      return "ICMS Desonerado";
    case TaxType.IBS:
      return "IBS";
    case TaxType.CBS:
      return "CBS";
    default:
      return "Desconhecido";
  }
};

export function AccordionCreated({ data }: { data: any[] }) {
  return (
    <AccordionItem value="created" className="border border-gray-200 rounded-lg shadow-sm bg-white">
      <AccordionTrigger className="px-4 py-3 hover:bg-gray-50 rounded-t-lg font-semibold text-gray-900">
        Novos Registros
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        {data.map((item, i) => (
          <div
            key={i}
            className="border border-gray-200 p-4 rounded-lg bg-gradient-to-br from-gray-50 to-gray-100/50 mb-3 last:mb-0 grid grid-cols-3 gap-4 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Estado</Label>
              <Input
                value={item.state}
                disabled
                className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Tipo de Tributo</Label>
              <Input
                value={getTaxTypeName(item.tip)}
                disabled
                className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Alíquota</Label>
              <Input
                value={`${(item.alq?.toString().replace(".", ",") ?? '0')}%`}
                disabled
                className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">CST</Label>
              <Input
                value={item.cst ?? "-"}
                disabled
                className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
              />
            </div>
            {item.cfop && (
              <div className="flex flex-col gap-1.5">
                <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">CFOP</Label>
                <Input
                  value={item.cfop}
                  disabled
                  className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
                />
              </div>
            )}
            {item.classification_tax && (
              <div className="flex flex-col gap-1.5">
                <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Classificação Fiscal</Label>
                <Input
                  value={item.classification_tax}
                  disabled
                  className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
                />
              </div>
            )}
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">
                Início de Vigência
              </Label>
              <Input
                value={format(new Date(item.initial_term), "dd/MM/yyyy", {
                  locale: ptBR,
                })}
                disabled
                className="bg-white border-gray-200 h-9 text-gray-900 font-medium shadow-sm"
              />
            </div>
          </div>
        ))}
      </AccordionContent>
    </AccordionItem>
  );
}
